import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';

import { AcknowledgeUserIdentityConflictsRequest } from '../requests/AcknowledgeUserIdentityConflictsRequest';
import { DisableIdentityMigrationInfoToastRequest } from '../requests/DisableIdentityMigrationInfoToastRequest';
import { GetUserIdentityConflictTotalsRequest,GetUserIdentityConflictTotalsResult } from '../requests/GetUserIdentityConflictTotalsRequest';
import { GetUserIdentityMigrationBackgroundJobRequest, IGetUserIdentityMigrationBackgroundJobResult } from '../requests/GetUserIdentityMigrationBackgroundJobRequest';
import { GetUserIdentityMigrationProgressRequest, GetUserIdentityMigrationProgressResult } from '../requests/GetUserIdentityMigrationProgressRequest';
import { ReevaluateUserIdentityConflictsRequest } from '../requests/ReevaluateUserIdentityConflictsRequest';
import { ResolveAmbiguousUserIdentityConflictRequest } from '../requests/ResolveAmbiguousUserIdentityConflictRequest';
import { RetryUserIdentityMigrationRequest } from '../requests/RetryUserIdentityMigrationRequest';
import { RunUserIdentityMigrationBackgroundJobNowRequest } from '../requests/RunUserIdentityMigrationBackgroundJobNowRequest';
import { ShouldShowIdentityMigrationInfoToastRequest } from '../requests/ShouldShowIdentityMigrationInfoToastRequest';

/**
 * This service is in charge of performing requests related to User Identity Conflicts.
 */
export namespace UserIdentityConflictsService {

  export function fetchUserIdentityMigrationBackgroundJob(): Promise<IGetUserIdentityMigrationBackgroundJobResult> {
    return WebHttpClient.sendRequest(new GetUserIdentityMigrationBackgroundJobRequest());
  }

  export function runUserIdentityMigrationBackgroundJobNow(): Promise<IResult> {
    return WebHttpClient.sendRequest(new RunUserIdentityMigrationBackgroundJobNowRequest());
  }

  export function fetchUserIdentityMigrationProgress(): Promise<GetUserIdentityMigrationProgressResult> {
    return WebHttpClient.sendRequest(new GetUserIdentityMigrationProgressRequest());
  }

  export function shouldShowIdentityMigrationInfoToast(): Promise<IResult> {
    return WebHttpClient.sendRequest(new ShouldShowIdentityMigrationInfoToastRequest());
  }

  export function disableIdentityMigrationInfoToast(): Promise<IResult> {
    return WebHttpClient.sendRequest(new DisableIdentityMigrationInfoToastRequest());
  }

  export function fetchUserIdentityConflictTotals(): Promise<GetUserIdentityConflictTotalsResult> {
    return WebHttpClient.sendRequest(new GetUserIdentityConflictTotalsRequest());
  }

  export function retryUserIdentityMigration(ids: string[]): Promise<IResult> {
    return WebHttpClient.sendRequest(new RetryUserIdentityMigrationRequest({ids: ids}));
  }

  export function acknowledgeUserIdentityConflicts(ids: string[]): Promise<IResult> {
    return WebHttpClient.sendRequest(new AcknowledgeUserIdentityConflictsRequest({ids: ids}));
  }

  export function reevaluateUserIdentityConflicts(ids: string[]): Promise<IResult> {
    return WebHttpClient.sendRequest(new ReevaluateUserIdentityConflictsRequest({ids: ids}));
  }

  export function resolveAmbiguousUserIdentityConflict(id: string, dataRecordId: string): Promise<IResult> {
    return WebHttpClient.sendRequest(new ResolveAmbiguousUserIdentityConflictRequest({id: id, dataRecordId: dataRecordId}));
  }
}
